module.exports = __webpack_public_path__ + "static/greyhat-3a67d78a1ec31e24e4a008f5cc023598.jpeg";